import './header.scss';

import {
	logoRotation
} from './logoRotation';
import {
	navbarAnimations
} from './navbarAnimations';
import {
	TimelineLite
} from 'gsap';

import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

export default (() => {
	$(document).ready(function () {
		/**
		 *  Home page animations
		 */

		const controller = new ScrollMagic.Controller();

		if ($('.header__logo').length > 0) {
			const logo = document.querySelector('.header__logo');
			const container = document.querySelector('.header');
			const center = document.querySelector('#logo_center');

			logoRotation(logo, container, center);

			// Logo scene
			new ScrollMagic.Scene({
				triggerElement: logo,
				offset: 50,
				triggerHook: '0.3'
			})
				.on('enter', e => {
					// Animation 1
					new TimelineLite()
						.to('.anim1', 0.5, {
							x: -15,
							y: -55,
							onStart: () => {
								logo.classList.add('scrolled');
							}
						})
						.to('.anim1', 0.5, {
							opacity: 0
						}, '-=0.25');
					// Animation 2
					new TimelineLite()
						.to('.anim2', 0.5, {
							x: -15,
							y: 55
						})
						.to('.anim2', 0.5, {
							opacity: 0
						}, '-=0.25');
					// SKY
					new TimelineLite()
						.to('#SKY', 0.5, {
							scale: 1.2
						})
						.to('#SKY', 0.5, {
							opacity: 0
						}, '-=0.25');
					// ROCKET
					new TimelineLite()
						.to('#ROCKET', 0.5, {
							x: 37,
							y: -70
						})
						.to('#ROCKET', 0.3, {
							opacity: 0
						});
				})
				.on('leave', e => {
					// Animation 1
					new TimelineLite()
						.to('.anim1', 0.5, {
							x: 0,
							y: 0,
							onComplete: () => {
								logo.classList.remove('scrolled');
							}
						})
						.to('.anim1', 0.5, {
							opacity: 1
						}, '-=0.25');
					// Animation 2
					new TimelineLite()
						.to('.anim2', 0.5, {
							x: 0,
							y: 0
						})
						.to('.anim2', 0.5, {
							opacity: 1
						}, '-=0.25');
					// SKY
					new TimelineLite()
						.to('#SKY', 0.5, {
							scale: 1
						})
						.to('#SKY', 0.5, {
							opacity: 1
						}, '-=0.25');
					// ROCKET
					new TimelineLite()
						.to('#ROCKET', 0.5, {
							x: 0,
							y: 0
						})
						.to('#ROCKET', 0.5, {
							opacity: 1
						}, '-=0.25');
				})
				.addTo(controller);
		}
	});
})();
